
export function modal() {
  let modal = document.querySelector('.js-modal');
  let modalTricky = document.querySelector('.js-modalTricky');
  let modalTriggers = document.querySelectorAll('.js-modalTrigger');
  let modalCloses = document.querySelectorAll('.js-modalClose');
  let body = document.querySelector('body');

  if(!modal) {
    return;
  }

  modalTriggers.forEach((item)=>{
    item.addEventListener('click', ()=>{

      let theModal = item.classList.contains("js-modalTrigger--tricky") ? modalTricky : modal;

      theModal.classList.add('is-active');
      body.classList.add('is-active');

      let conts = {
        img: item.querySelector(".js-modalCont").dataset.img,
        logo: item.querySelector(".js-modalCont").dataset.logo,
        logoLink: item.querySelector(".js-modalCont").dataset.logolink,
        products: item.querySelector(".js-modalCont").dataset.products,
        desc: item.querySelector(".js-modalCont").dataset.desc,
      };

      theModal.querySelector(".c-modal_img").src = conts.img;
      theModal.querySelector(".c-modal_logo").src = conts.logo;
      theModal.querySelector(".c-modal_products").innerHTML = conts.products;
      theModal.querySelector(".c-modal_desc").innerHTML = conts.desc;

      if(conts.logoLink) {
        theModal.querySelector(".c-modal_logoLink").href = conts.logoLink;
      }else {
        theModal.querySelector(".c-modal_logoLink").classList.add('is-disabled');
      };

      if(item.classList.contains("js-modalTrigger--tricky")) {
        conts.staffImg = item.querySelector(".js-modalCont").dataset.staffimg;
        conts.staffName = item.querySelector(".js-modalCont").dataset.staffname;

        theModal.querySelector(".c-modal_staffImg").src = conts.staffImg;
        theModal.querySelector(".c-modal_staffName").innerHTML = conts.staffName;
      }
    })
  })

  modalCloses.forEach((item)=>{
    item.addEventListener('click', ()=>{
      modal.classList.remove('is-active');
      modalTricky.classList.remove('is-active');
      body.classList.remove('is-active');
    });
  })
}